(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDialogController', PhoneCallCheckDialogController);

    /* Added AdvertisingSource, $locale, Principal, $filter, PhoneCallCheckTrackerService, AlertService, $translate
    PhoneCallCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose'];

    function PhoneCallCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose) {
    */
    PhoneCallCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose', 'AdvertisingSource', '$locale', 'Principal', '$filter', 'PhoneCallCheckTrackerService', 'AlertService', '$translate'];

    function PhoneCallCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose, AdvertisingSource, $locale, Principal, $filter, PhoneCallCheckTrackerService, AlertService, $translate) {
        var vm = this;

        vm.infoCallBack = infoCallBack;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
            PhoneCallCheckTrackerService.setEditListener().then(
                null, null,
                function (dto) {
                    infoCallBack(dto);
                }
            );
        }

        vm.otherInfo = '';
        vm.fatalInfo = '';
        vm.warnSuppress = {};

        vm.phoneCallCheck = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.playerSetSpeed = playerSetSpeed;
        vm.save = save;
        /* -- Начало удаленного куска
        // Удалено из-за отсутствия необходимости выбора/смены phone-call в phone-call-check,
        // т.к. phone-call связывается с phone-call-check либо при создании новой связки на странице phone-call,
        // либо со стороны сервера приходит готовый объект.
        vm.phonecalls = PhoneCall.query({filter: 'phonecallcheck-is-null'});
        $q.all([vm.phoneCallCheck.$promise, vm.phonecalls.$promise]).then(function() {
            if (!vm.phoneCallCheck.phoneCall || !vm.phoneCallCheck.phoneCall.id) {
                return $q.reject();
            }
            return PhoneCall.get({id : vm.phoneCallCheck.phoneCall.id}).$promise;
        }).then(function(phoneCall) {
            vm.phonecalls.push(phoneCall);
        });
        -- Конец удаленного куска */

        vm.realtytypes = RealtyType.query();
        vm.phonecallresults = PhoneCallResult.query();
        /* ненужные тяжелые вызовы к API
        vm.users = User.query();
        vm.employees = Employee.query();
        */
        /*
        vm.phonecallpurposes = PhoneCallPurpose.query();
        */
        vm.phonecallpurposes = PhoneCallPurpose.query({sort: 'checkOrder,asc'});
        vm.advertisingsources = AdvertisingSource.query({size: 9999, sort: 'name,asc', actual: false});
        vm.dateformat = $locale.DATETIME_FORMATS.short;
        vm.calcProps = calcProps;
        if(vm.phoneCallCheck.id == null) {
            vm.phoneCallId = $stateParams.id;
            calcProps(true);
        } else {
            vm.phoneCallId = vm.phoneCallCheck.phoneCall.id;
        }
        $q.all([vm.phoneCallCheck.phoneCall.$promise]).then(function(){
            vm.phoneCallId = vm.phoneCallCheck.phoneCall.id;
            calcTitle();
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallCheck.id !== null) {
                PhoneCallCheck.update(vm.phoneCallCheck, onSaveSuccess, onSaveError);
            } else {
                PhoneCallCheck.save(vm.phoneCallCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallCheckUpdate', result);
            PhoneCallCheckTrackerService.sendSavePhoneCallId(vm.phoneCallId);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.checkTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function playerSetSpeed(id, speed) {
            var audio = document.getElementById(id);
	    audio.playbackRate = speed; 
        }

        // Refers to ru.inquarta.telestat.domain.PhoneCallCheckExtender
        function calcProps(firstRun) {
            if (firstRun != true) {
                PhoneCallCheckTrackerService.sendEditPhoneCallId(vm.phoneCallId);
            }
            // assessment
            if (vm.phoneCallCheck.phoneCallPurposes != null) {
                vm.phoneCallCheck.assessment = vm.phoneCallCheck.phoneCallPurposes.reduce(
                    function (sum, current) {
                        return sum + current.worth;
                    }, 0);
            } else {
                vm.phoneCallCheck.assessment = 0;
            }
            if(vm.phoneCallCheck.phoneCallResult != null) {
                switch (vm.phoneCallCheck.phoneCallResult.phoneCallResultGroup.code) {
                    case 'missed'://MISSED_CODE
                        vm.phoneCallCheck.assessment = 0;
                        break;
                    case 'indefin'://INDEFINITE_CODE
                    case 'insignif'://INSIGNIFICANT_CODE
                        vm.phoneCallCheck.assessment = null;
                        break;
                    case 'product'://PRODUCTIVE_CODE
                    case 'useless'://USELESS_CODE
                    default:
                }
            }
            // checkerCaption
            Principal
                .identity()
                .then(function(account) {
                    var caption = "";
                    if(account.lastName != '') {
                        caption += account.lastName;
                    }
                    if(account.firstName != '' && account.firstName != account.lastName) {
                        if(caption.length > 0) {
                            caption += " ";
                        }
                        caption += account.firstName;
                    }
                    if(caption.length == 0) {
                        caption = account.login;
                    }
                    vm.phoneCallCheck.checkerCaption = caption;
                });
            // checkTime
            if(vm.phoneCallCheck.checkTime == null) {
                vm.phoneCallCheck.checkTime = new Date();
            }
        }

        function calcTitle() {
            var title = $filter('date')(vm.phoneCallCheck.phoneCall.callTime, 'dd.MM.yy HH:mm') + " " + vm.phoneCallCheck.phoneCall.callingCaption + " → " + vm.phoneCallCheck.phoneCall.calledCaption;
            if (vm.phoneCallCheck.phoneCall.calledEmployee != null) {
                title += " (" + vm.phoneCallCheck.phoneCall.calledEmployee.division.name + ")";
            }
            vm.phoneCallCheck.phoneCall.title = title;
        }

        function infoCallBack(dto) {
            //console.log("EDIT INFO CALL BACK:");
            //console.log(dto);
            if (vm.phoneCallId == dto.phoneCallId) {
                if (dto.action == 'edit') {
                    if (vm.warnSuppress[dto.sessionId] == null) {
                        vm.otherInfo = $translate.instant('global.concurrentEdit', dto);
                        vm.warnSuppress[dto.sessionId] = 1;
                    }
                } else if (dto.action == 'close') {
                    if ($translate.instant('global.concurrentEdit', dto) == vm.otherInfo) {
                        vm.otherInfo = '';
                    }
                    delete vm.warnSuppress[dto.sessionId];
                } else if (dto.action == 'save') {
                    vm.fatalInfo = $translate.instant('global.concurrentSave', dto);
                    delete vm.warnSuppress[dto.sessionId];
                }
            }
        }

    }
})();
